import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Message } from "element-ui";
import { UserModule } from "@/store/modules/user";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API + "/hq-lms", // url = base url + request url
  timeout: 120000
  // withCredentials: true // send cookies when cross-domain requests
});

// Request interceptors
service.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (UserModule.token && config && config.headers) {
      config.headers["X-Access-Token"] = UserModule.token;
      config.headers["Authorization"] = UserModule.token;
    }
    return config;
  },
  (error: ErrorEvent) => {
    Promise.reject(error);
  }
);

// Response interceptors
service.interceptors.response.use(
  (response: AxiosResponse) => {
    // const res:any = response.data;
    // response.status
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || "Error",
    //     type: "error",
    //     duration: 5 * 1000
    //   });
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     MessageBox.confirm(
    //       "你已被登出，可以取消继续留在该页面，或者重新登录",
    //       "确定登出",
    //       {
    //         confirmButtonText: "重新登录",
    //         cancelButtonText: "取消",
    //         type: "warning"
    //       }
    //     ).then(() => {
    //       UserModule.ResetToken();
    //       location.reload(); // To prevent bugs from vue-router
    //     });
    //   }
    //   return Promise.reject(new Error(res.message || "Error"));
    // } else {
    //   return response.data;
    // }
    return response.data || response;
  },
  (error: any) => {
    const message =
      error.response?.data?.message ||
      error.response?.data ||
      (error.code === "ECONNABORTED" ? "请求超时" : error.message) ||
      "网络错误";
    Message({
      message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);


export default service;
